export default __webpack_public_path__ + "static/media/table-sorted-asc.8ac857a7.svg";